import React, { useState } from 'react';
import { createGlobalStyle, css } from 'styled-components';
import { ThemeProvider, ThemeContext } from '../ui';
import { theme } from '../ui/system';
// import { useStaticQuery, graphql } from 'gatsby';
// import { FocusRing } from 'react-tinacms-inline';
// import { FocusRing } from '../blocks/inline/BlocksControls';

const primaryColor = theme.colors.primary.main;

export const Theme = React.memo(({ children }) => {
  // const data = useStaticQuery(graphql`
  //   query ThemeQuery {
  //     settingsJson(fileRelativePath: { eq: "/content/settings/theme.json" }) {
  //       ...globalTheme
  //     }
  //   }
  // `);
  return (
    <ThemeProvider>
      <ThemeContext.Consumer>
        {theme => (
          <>
            <TinaOverrideGlobalStyle primary={theme.colors.primary.main} />
            <GlobalStyles />
            {children}
          </>
        )}
      </ThemeContext.Consumer>
    </ThemeProvider>
  )
})


const TinaOverrideGlobalStyle = createGlobalStyle`
  :root {
    --tina-color-primary-light: ${props => props.primary};
    --tina-color-primary: ${props => props.primary};
    --tina-color-primary-dark: ${props => props.primary};
  }
`

const Reset = css`
  /*! minireset.cssd v0.0.5 | MIT License | github.com/jgthms/minireset.css */
  html,
  body,
  p,
  ol,
  ul,
  li,
  dl,
  dt,
  dd,
  blockquote,
  figure,
  fieldset,
  legend,
  textarea,
  pre,
  iframe,
  hr,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
    padding: 0;
    -webkit-font-smoothing: antialiased;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: 100%;
    font-weight: normal;
  }

  ul {
    list-style: none;
  }

  button,
  input,
  select,
  textarea {
    margin: 0;
  }

  html {
    box-sizing: border-box;
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  img,
  video {
    height: auto;
    max-width: 100%;
  }

  iframe {
    border: 0;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  td,
  th {
    padding: 0;
    text-align: left;
  }

  input:focus {
    outline: transparent;
  }

  textarea:focus {
    outline: transparent;
  }

  body {
    overflow-y: scroll;
  }
`

const GlobalStyles = createGlobalStyle`${Reset}`

// export const globalThemeFragment = graphql`
//   fragment globalTheme on SettingsJson {
//     colors {
//       black
//       white
//       primary
//       secondary
//       gray1
//       gray2
//       gray3
//       gray4
//       gray5
//       gray6
//     }
//     breakpoints {
//       xs
//       sm
//       md
//       lg
//       xl
//     }
//     density
//     spacing
//     header {
//       overline
//       underline
//       transparent
//       height
//     }
//     hero {
//       image {
//         childImageSharp {
//           fluid(quality: 70, maxWidth: 1920) {
//             ...GatsbyImageSharpFluid_withWebp
//           }
//         }
//       }
//       large
//       overlay
//       overlap
//       parallax
//     }
//     typography {
//       uppercaseH2
//     }
//   }
// `
